import {AppStartListening} from "../../store";
import {ListenerEffectAPI, PayloadAction, Unsubscribe} from "@reduxjs/toolkit";
import {loadClubs, loadPrepaidBagProducts} from "./asyncActions";
import {LoadUserActionPayload} from "../session/slice";
import {refreshSession} from "../session/asyncActions";
import {handleClubChange} from "./slice";

const handlePostClubChange = async (action: PayloadAction<string | undefined>, listenerApi: ListenerEffectAPI<any, any>) => {
    if (action.payload) {
        listenerApi.dispatch(loadPrepaidBagProducts())
    }
}

const handleUserLoaded = async (_: PayloadAction<LoadUserActionPayload>, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(loadClubs())
}

export function setupClubListeners(startListening: AppStartListening): Unsubscribe {
    const subscriptions = [
        startListening({
            actionCreator: refreshSession.fulfilled,
            effect: handleUserLoaded,
        }),
        startListening({
            actionCreator: handleClubChange,
            effect: handlePostClubChange,
        }),
    ]

    return () => {
        subscriptions.forEach((unsubscribe) => unsubscribe())
    }
}